import { Box, IconButton, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

interface ExpandMoreProps {
  expand: number;
}

export const Wrapper = styled(Box)(({ theme }) => ({
  flexGrow: 1,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  marginTop: '10px',
  overflow: 'hidden',

  '> svg': {
    marginBottom: '10px',
  },

  [theme.breakpoints.down('sm')]: {
    minHeight: 'calc(100vh - 110px)',
    overflow: 'auto',

    '> svg': {
      marginBottom: '15px',
    },
  },
}));

export const Description = styled(Typography)(({ theme }) => ({
  margin: '5px 0 40px',
  color: 'rgba(108, 106, 124, 1)',

  [theme.breakpoints.down('sm')]: {
    margin: '10px 0 20px',
  },
}));

export const InnerContainer = styled(Box)(({ theme }) => ({
  flexGrow: 1,
  display: 'flex',
  flexDirection: 'column',
  maxWidth: '750px',
  width: '100%',
  overflow: 'hidden',
  boxSizing: 'border-box',

  '.MuiButton-containedSecondary': {
    marginTop: '20px',
  },

  [theme.breakpoints.down('sm')]: {
    overflow: 'auto',

    '.MuiButton-containedSecondary': {
      marginTop: '10px',
    },
  },
}));

export const Cards = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '20px',
  marginBottom: '40px',
  width: '100%',
  overflow: 'auto',
  minHeight: '60px',

  [theme.breakpoints.down('sm')]: {
    gap: '10px',
    marginBottom: '32px',
    overflow: 'hidden',
  },
}));

export const ButtonsContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: '20px',
  marginTop: 'auto',

  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
  },
}));

export const ConnectorCard = styled(Box)(() => ({
  padding: '17px 20px',
  background: 'rgba(239, 239, 244, 1)',
  borderRadius: '6px',
  width: '100%',
  boxSizing: 'border-box',
}));

export const ConnectorCardHeader = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
}));

export const AccountsContainer = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '10px',
  marginTop: '10px',
}));

export const Account = styled(Box)(() => ({
  border: '1px solid rgba(221, 221, 234, 1)',
  borderRadius: '6px',
}));

export const PropertiesContainer = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '5px',
  padding: '10px',
}));

export const ExpandMore = styled(IconButton)<ExpandMoreProps>(
  ({ theme, expand }) => ({
    transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),

    '.MuiSvgIcon-root': {
      fill: expand ? 'rgba(34, 40, 34, 1)' : 'rgba(159, 159, 159, 1)',
    },
  }),
);
